<template>
<div class="nctouch-cart-container">
    <!--发票信息Begin-->
    <div class="nctouch-cart-block"> <a href="javascript:void(0);" class="posr" @click="chooseInvoice">
        <h3>发票信息</h3>
        <div class="current-con">
            <p>{{resultContent}}</p>
        </div>
        <i class="icon-arrow"></i> </a> </div>
    <!--发票信息End-->

    <!--管理发票信息Begin-->
    <div id="invoice-wrapper" :class="['nctouch-full-mask', paymentWrapperClass]">
        <div class="nctouch-full-mask-bg"></div>
        <div class="nctouch-full-mask-block">
            <div class="header">
                <div class="header-wrap">
                    <div class="header-l"> <a href="javascript:void(0);" @click="goBack"> <i class="back"></i> </a> </div>
                    <div class="header-title">
                        <h1>发票信息设置</h1>
                    </div>
                </div>
            </div>
            <div class="nctouch-main-layout">
                <div id="invoice-div" class="">

                    <div class="nctouch-inp-con" id="invoice_adds">
                        <ul class="form-box">
                            <li class="form-item" id="inv-title-li">
                                <h4><b>发票抬头</b></h4>
                                <div :class="['input-box',inputTitleClass]">
                                    <input type="text" class="inp" v-model.trim="invoiceTitle" name="inv_title" value="" placeholder="请输入发票抬头">
                                    <span class="input-del1" @click="inputDel()" ref="inputDel"></span> </div>
                            </li>
                            <li ref="titleList" class="nctouch-sel-list" v-show="showTitleList">
                                <div>
                                    <label v-for="v in titleList" @click="chooseTitle(v.title,v.code)" style="padding:0.3rem 0">&nbsp;&nbsp;{{v.title}}</label>
                                </div>
                            </li>
                            <li class="form-item">
                                <h4><b>纳税人识别号</b></h4>
                                <div :class="['input-box',inputCodeClass]">
                                    <input type="text" class="inp" v-model.trim="invoiceCode" name="inv_code"  value="" placeholder="开企业发票请填写此项，以免影响报销" maxlength="50">
                                    <span class="input-del1" @click="inputCodeDel()" ref="inputCodeDel"></span>
                                </div>
                            </li>
                            <li class="form-item">
                                <h4><b>发票内容</b></h4>
                                <div class="input-box">
                                    <input type="text" class="inp" v-model="invoiceContent" readonly @click="invoiceContentSelect">
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
                <div class="nctouch-sel-box">
                    <div class="sel-con pt5"> <a href="javascript:void(0);" :class="{sel:!isNeed}" @click="noneInvoice"><i></i>不开发票</a> <a href="javascript:void(0);" @click="saveInvoice" :class="{sel:isNeed}"><i></i>保存并使用发票</a></div>
                </div>
            </div>
        </div>
    </div>
    <!--管理发票信息End-->


    <!-- 底部平台红包选择固定层 Begin -->
    <transition name="ncbottom">
        <div class="nctouch-bottom-mask mask-show" v-show="invoiceContentShow">
            <div :class="['nctouch-bottom-mask-bg','J-voucher-close']" @click="invoiceContentShow=false"></div>
            <div class="nctouch-bottom-mask-block">
                <div class="nctouch-bottom-mask-top">
                    <div class="close J-voucher-close"><i class="closed" @click="invoiceContentShow=false"></i>选择发票内容</div>
                </div>
                <div class="city-options">
                    <div class="city-content">
                        <div class="city-select-panel">
                            <ul>
                                <li>
                                    <div class="city-item-scroll" ref='contentList'>
                                        <dl class="city-item">
                                            <a href="javascript:;"
                                               v-for="v in contentList"
                                               @click="invoiceContent = v;invoiceContentShow=false"
                                               :class="{checked:invoiceContent && invoiceContent==v}">
                                                <h4>{{v}}</h4><i></i></a>
                                        </dl>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
    <!-- 底部平台红包选择固定层 End -->

    </div>
</template>
<script>
    // js 区域 

    var contentScroll;
    export default {
        //外部传入参数
        props: {
        },
        /*
         * 自身数据,一定要一个function
         */
        data: function(){
            return {
                invoiceTitle : "个人",
                invoiceContent : "",
                invoiceCode : "",
                paymentWrapperClass: 'hide',
                contentList: null,
                titleList: null,
                myScroll: null,
                inputTitleClass: "write",
                inputCodeClass: "write",
                showTitleList: false,
                resultContent: "不需要发票",
                isNeed: false,
                invoiceContentShow: false
            }
        },
        /**
         * 计算属性
         */
        computed: {},
        /**
         * 过滤器
         */
        filters: {

        },
        /**
         * 生命周期钩子
         */

        /**
         * 自定义方法
         */
        methods: {
            chooseInvoice: function(){
                var $this = this;
                $this.paymentWrapperClass = "left";
                if ($this.contentList == null) {
                    $.ajax({
                        type:'post',
                        url:ApiUrl+'/member/invoice/content/list',
                        data:{token:getMemberToken()},
                        dataType:'json',
                        success:function(result){
                            if (result.code == 200) {
                                $this.contentList = result.datas.contentList;
                                $this.invoiceContent = result.datas.contentList[0];
                            }
                        }
                    });
                }
            },
            /**
             * 清空输入的发票抬头信息
             **/
            inputDel: function(){
                this.inputTitleClass = "";
                this.invoiceTitle = "";
            },
            /**
             * 清空输入的发票识别号信息
             **/
            inputCodeDel: function(){
                this.inputCodeClass = "";
                this.invoiceCode = "";
            },
            /**
             * 选择发票
             **/
            chooseTitle: function(title,code){
                this.invoiceTitle = title;
                this.invoiceCode = code;
                this.showTitleList = false;
                this.inputTitleClass = "write";
            },
            /**
             * 保存并使用发票
             **/
            saveInvoice: function(){
                this.isNeed = true;
                this.paymentWrapperClass = "right";
                this.$emit('choose-invoice', this.invoiceTitle,this.invoiceContent,this.invoiceCode);
                this.resultContent = "普通发票" + " " + this.invoiceTitle + " " +  this.invoiceContent;
                if (this.invoiceTitle != "个人") {
                    //新增发票
                    var param = {};
                    param.token = getMemberToken();
                    param.title = this.invoiceTitle;
                    param.code = this.invoiceCode;
                    $.ajax({
                        type: 'post',
                        url: ApiUrl + '/member/invoice/add',
                        data: param,
                        dataType: 'json'
                    });
                }
                this.titleList = null;
            },
            /**
             * 不使用发票
             **/
            noneInvoice: function(){
                this.isNeed = false;
                this.paymentWrapperClass = "right";
                this.invoiceTitle = "个人";
                this.invoiceContent = "明细";
                this.$emit('choose-invoice', "","","");
                this.resultContent = "不需要发票";
            },
            /**
             * 返回
             **/
            goBack: function(){
                this.paymentWrapperClass = "right";
            },
            /**
             * 发票内容选择
             */
            invoiceContentSelect: function(){
                var $this = this;
                $this.invoiceContentShow = true;
                $this.$nextTick(function(){
                    /**
                     * 添加滑动特效
                     */
                    if (typeof contentScroll == 'undefined') {
                        contentScroll = new IScroll($this.$refs.contentList, {
                            scrollX: false,
                            scrollY: true,
                            click: true
                        });
                    }
                });

            }
        },
        /**
         * 监听数据变更
         */
        watch: {
            invoiceCode: function(value){
                if (value != null) {
                    this.invoiceCode = value.replace(/[^0-9a-zA-Z]+/,'').toUpperCase();
                }
            },
            invoiceTitle: function(title){
                var $this = this;
                if (title == '') {
                    console.log("获取已有的发票抬头列表");
                    this.inputTitleClass = "";
                    if ($this.titleList == null) {
                        $.ajax({
                            type:'post',
                            url:ApiUrl + "/member/invoice/list",
                            data:{token:getMemberToken()},
                            dataType:'json',
                            success:function(xhr){
                                if (xhr.code != 200) {
                                    alertError(xhr.datas.error);
                                } else {
                                    $this.titleList = xhr.datas.invoiceList;
                                    $this.$nextTick(function () {
                                        if ($this.myScroll == null) {
                                            $this.myScroll = new IScroll($this.$refs.titleList, {
                                                scrollX: false,
                                                scrollY: true,
                                                click : true
                                            });
                                        }
                                    });
                                    if ($this.titleList && $this.titleList.length > 0) {
                                        $this.showTitleList = true;
                                    }
                                }
                            }
                        });
                    } else {
                        if ($this.titleList && $this.titleList.length > 0) {
                            $this.showTitleList = true;
                            $this.myScroll.refresh()
                        } else {
                            $this.showTitleList = false;
                        }
                    }
                } else {
                    this.inputTitleClass = "write";
                    $this.showTitleList = false;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/buy-invoice/buy-invoice.vue